import TextLinkWithFileIcon from './container'
export default TextLinkWithFileIcon
